import { API, ApiResponseBase, CustomAxiosError } from "../../../../../logics/api-config";
import { IAccounting } from "../../../../../utils/interfaces/Accounting/Recap/IAccounting";
import { useQuery, UseQueryResult } from "react-query";

export interface ApiResponse extends ApiResponseBase {
    data: IAccounting;
}

async function doGet(year: string, month: string): Promise<IAccounting> {
    const response = await API.get(`/accounting/recap/cash_transactions/${year}/${month}`);
    return response?.data;
}

const useApiGetAccountingCashRecap = (
    year: string,
    month: string,
    options: any = {}
): UseQueryResult<IAccounting, CustomAxiosError> => {
    return useQuery<IAccounting, CustomAxiosError>(
        ["getAccountingCashRecap", year, month],
        () => doGet(year, month),
        { ...options }
    );
};

export default useApiGetAccountingCashRecap;